import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UAVCommand } from '../../model/uavcommand';
import { GenericAkitaHTTPService, HttpOptions } from '../../service/generic-akita-http.service';
import { NetworkService } from '../../service/network.service';


@Injectable({
  providedIn: 'root'
})
export class UAVCommandHTTPService extends GenericAkitaHTTPService<UAVCommand> {
  constructor(http: HttpClient, networkService: NetworkService) {
    const options: HttpOptions = {
      params: {
        type: 'UAVCommand',
        options: 'keyValues',
        limit: '100'
      }
    };
    super(http, networkService, '/v2/entities/', 'UAVCommand', options);
  }

}
